module.exports = __webpack_public_path__ + "img/lg_versan.320894d2.png";